define(["exports", "@babel/runtime/helpers/esm/extends", "react", "styled-components", "../../themes"], function (_exports, _extends2, _react, _styledComponents, _themes) {
  "use strict";

  var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.RatingEmojis = void 0;
  _extends2 = _interopRequireDefault(_extends2);
  _react = _interopRequireDefault(_react);
  _styledComponents = _interopRequireWildcard(_styledComponents);

  var StyledEmoji = _styledComponents.default.span.withConfig({
    displayName: "RatingEmojis__StyledEmoji",
    componentId: "sc-1vuos0e-0"
  })(["border:2px solid ", ";border-radius:50%;box-sizing:content-box;display:inline-block;", ";", ";", ";svg{display:block;height:100%;width:100%;}"], function (_ref) {
    var theme = _ref.theme;
    return theme.colors.white;
  }, function (_ref2) {
    var size = _ref2.size;
    return size === 'small' && (0, _styledComponents.css)(["", ";"], (0, _themes.size)(16));
  }, function (_ref3) {
    var size = _ref3.size;
    return size === 'medium' && (0, _styledComponents.css)(["", ";"], (0, _themes.size)(24));
  }, function (_ref4) {
    var size = _ref4.size;
    return size === 'large' && (0, _styledComponents.css)(["", ";"], (0, _themes.size)(32));
  });

  var RatingEmojis = function RatingEmojis(_ref5) {
    var size = _ref5.size,
        kind = _ref5.kind,
        rest = _ref5.rest;

    switch (kind) {
      case 3:
        return /*#__PURE__*/_react.default.createElement(StyledEmoji, (0, _extends2.default)({
          size: size
        }, rest), /*#__PURE__*/_react.default.createElement("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "32",
          height: "32",
          fill: "none",
          viewBox: "0 0 32 32"
        }, /*#__PURE__*/_react.default.createElement("circle", {
          cx: "15.998",
          cy: "15.998",
          r: "15.998",
          fill: "#fff"
        }), /*#__PURE__*/_react.default.createElement("path", {
          fill: "#DA3333",
          d: "M16 0C7.178 0 0 7.178 0 16s7.178 16 16 16 16-7.178 16-16S24.822 0 16 0zm6.698 17.184L16 23.882l-6.698-6.698c-1.742-1.74-1.742-4.5 0-6.251 1.75-1.741 4.51-1.741 6.25 0l.448.446.446-.446c1.741-1.741 4.501-1.741 6.25 0 1.742 1.75 1.742 4.509.002 6.251z"
        })));

      case 3.1:
        return /*#__PURE__*/_react.default.createElement(StyledEmoji, (0, _extends2.default)({
          size: size
        }, rest), /*#__PURE__*/_react.default.createElement("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "38",
          height: "38",
          fill: "none",
          viewBox: "0 0 38 38"
        }, /*#__PURE__*/_react.default.createElement("circle", {
          cx: "15.998",
          cy: "15.998",
          r: "15.998",
          fill: "#fff"
        }), /*#__PURE__*/_react.default.createElement("path", {
          fill: "#797979",
          d: "M16 0C7.178 0 0 7.178 0 16s7.178 16 16 16 16-7.178 16-16S24.822 0 16 0zm6.698 17.184L16 23.882l-6.698-6.698c-1.742-1.74-1.742-4.5 0-6.251 1.75-1.741 4.51-1.741 6.25 0l.448.446.446-.446c1.741-1.741 4.501-1.741 6.25 0 1.742 1.75 1.742 4.509.002 6.251z"
        }), /*#__PURE__*/_react.default.createElement("path", {
          fill: "#FA6400",
          d: "M30 23.333c-3.676 0-6.667 2.99-6.667 6.667 0 3.676 2.99 6.667 6.667 6.667 3.676 0 6.667-2.991 6.667-6.667 0-3.676-2.991-6.667-6.667-6.667zm2.805 8.529l-.943.943L30 30.943l-1.862 1.862-.943-.943L29.057 30l-1.862-1.862.943-.943L30 29.057l1.862-1.862.943.943L30.943 30l1.862 1.862z"
        })));

      case 2:
        return /*#__PURE__*/_react.default.createElement(StyledEmoji, (0, _extends2.default)({
          size: size
        }, rest), /*#__PURE__*/_react.default.createElement("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "32",
          height: "32",
          fill: "none",
          viewBox: "0 0 32 32"
        }, /*#__PURE__*/_react.default.createElement("circle", {
          cx: "15.998",
          cy: "15.998",
          r: "15.998",
          fill: "#7A5A28"
        }), /*#__PURE__*/_react.default.createElement("path", {
          fill: "#F7B500",
          d: "M16 0C7.178 0 0 7.178 0 16s7.178 16 16 16 16-7.178 16-16S24.822 0 16 0zm5.589 9.6c1.318 0 2.389 1.07 2.389 2.389 0 1.318-1.07 2.389-2.39 2.389-1.318 0-2.388-1.07-2.388-2.39 0-1.318 1.07-2.388 2.389-2.388zM10.4 9.6c1.325 0 2.4 1.075 2.4 2.4s-1.075 2.4-2.4 2.4S8 13.325 8 12s1.075-2.4 2.4-2.4zm5.6 16c-8 0-9.6-8-9.6-8h19.2s-1.6 8-9.6 8z"
        })));

      case 2.1:
        return /*#__PURE__*/_react.default.createElement(StyledEmoji, (0, _extends2.default)({
          size: size
        }, rest), /*#__PURE__*/_react.default.createElement("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "38",
          height: "38",
          fill: "none",
          viewBox: "0 0 38 38"
        }, /*#__PURE__*/_react.default.createElement("circle", {
          cx: "15.998",
          cy: "15.998",
          r: "15.998",
          fill: "#fff"
        }), /*#__PURE__*/_react.default.createElement("path", {
          fill: "#797979",
          d: "M16 0C7.178 0 0 7.178 0 16s7.178 16 16 16 16-7.178 16-16S24.822 0 16 0zm5.589 9.6c1.318 0 2.389 1.07 2.389 2.389 0 1.318-1.07 2.389-2.39 2.389-1.318 0-2.388-1.07-2.388-2.39 0-1.318 1.07-2.388 2.389-2.388zM10.4 9.6c1.325 0 2.4 1.075 2.4 2.4s-1.075 2.4-2.4 2.4S8 13.325 8 12s1.075-2.4 2.4-2.4zm5.6 16c-8 0-9.6-8-9.6-8h19.2s-1.6 8-9.6 8z"
        }), /*#__PURE__*/_react.default.createElement("path", {
          fill: "#FA6400",
          d: "M30 23.333c-3.676 0-6.667 2.99-6.667 6.667 0 3.676 2.99 6.667 6.667 6.667 3.676 0 6.667-2.991 6.667-6.667 0-3.676-2.991-6.667-6.667-6.667zm2.805 8.529l-.943.943L30 30.943l-1.862 1.862-.943-.943L29.057 30l-1.862-1.862.943-.943L30 29.057l1.862-1.862.943.943L30.943 30l1.862 1.862z"
        })));

      case 1:
        return /*#__PURE__*/_react.default.createElement(StyledEmoji, (0, _extends2.default)({
          size: size
        }, rest), /*#__PURE__*/_react.default.createElement("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "32",
          height: "32",
          fill: "none",
          viewBox: "0 0 32 32"
        }, /*#__PURE__*/_react.default.createElement("circle", {
          cx: "15.998",
          cy: "15.998",
          r: "15.998",
          fill: "#7A5A28"
        }), /*#__PURE__*/_react.default.createElement("path", {
          fill: "url(#prefix__paint0_linear)",
          d: "M16 0C7.178 0 0 7.178 0 16s7.178 16 16 16 16-7.178 16-16S24.822 0 16 0zM8 13.6c0-1.325 1.075-2.4 2.4-2.4s2.4 1.075 2.4 2.4-1.075 2.4-2.4 2.4S8 14.925 8 13.6zM22.4 24H9.558v-3.2H22.4V24zm-.811-8.022c-1.319 0-2.389-1.07-2.389-2.39 0-1.318 1.07-2.388 2.389-2.388 1.318 0 2.389 1.07 2.389 2.389 0 1.318-1.07 2.389-2.39 2.389z"
        }), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("linearGradient", {
          id: "prefix__paint0_linear",
          x1: "16",
          x2: "16",
          y1: "0",
          y2: "32",
          gradientUnits: "userSpaceOnUse"
        }, /*#__PURE__*/_react.default.createElement("stop", {
          stopColor: "#F7902A"
        }), /*#__PURE__*/_react.default.createElement("stop", {
          offset: "1",
          stopColor: "#F7B500"
        })))));

      case 1.1:
        return /*#__PURE__*/_react.default.createElement(StyledEmoji, (0, _extends2.default)({
          size: size
        }, rest), /*#__PURE__*/_react.default.createElement("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "38",
          height: "38",
          fill: "none",
          viewBox: "0 0 38 38"
        }, /*#__PURE__*/_react.default.createElement("circle", {
          cx: "15.998",
          cy: "15.998",
          r: "15.998",
          fill: "#fff"
        }), /*#__PURE__*/_react.default.createElement("path", {
          fill: "#797979",
          d: "M16 0C7.178 0 0 7.178 0 16s7.178 16 16 16 16-7.178 16-16S24.822 0 16 0zM8 13.6c0-1.325 1.075-2.4 2.4-2.4s2.4 1.075 2.4 2.4-1.075 2.4-2.4 2.4S8 14.925 8 13.6zM22.4 24H9.558v-3.2H22.4V24zm-.811-8.022c-1.319 0-2.389-1.07-2.389-2.39 0-1.318 1.07-2.388 2.389-2.388 1.318 0 2.389 1.07 2.389 2.389 0 1.318-1.07 2.389-2.39 2.389z"
        }), /*#__PURE__*/_react.default.createElement("path", {
          fill: "#FA6400",
          d: "M30 23.333c-3.676 0-6.667 2.99-6.667 6.667 0 3.676 2.99 6.667 6.667 6.667 3.676 0 6.667-2.991 6.667-6.667 0-3.676-2.991-6.667-6.667-6.667zm2.805 8.529l-.943.943L30 30.943l-1.862 1.862-.943-.943L29.057 30l-1.862-1.862.943-.943L30 29.057l1.862-1.862.943.943L30.943 30l1.862 1.862z"
        })));

      case -1:
        return /*#__PURE__*/_react.default.createElement(StyledEmoji, (0, _extends2.default)({
          size: size
        }, rest), /*#__PURE__*/_react.default.createElement("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "32",
          height: "32",
          fill: "none",
          viewBox: "0 0 32 32"
        }, /*#__PURE__*/_react.default.createElement("circle", {
          cx: "15.998",
          cy: "15.998",
          r: "15.998",
          fill: "#7A5A28"
        }), /*#__PURE__*/_react.default.createElement("path", {
          fill: "url(#prefix__paint0_linear)",
          d: "M16 0C7.178 0 0 7.178 0 16s7.178 16 16 16 16-7.178 16-16S24.822 0 16 0zM8 13.6c0-1.325 1.075-2.4 2.4-2.4s2.4 1.075 2.4 2.4-1.075 2.4-2.4 2.4S8 14.925 8 13.6zM9.6 24s1.6-4.8 6.4-4.8c4.8 0 6.4 4.8 6.4 4.8H9.6zm11.989-8.022c-1.319 0-2.389-1.07-2.389-2.39 0-1.318 1.07-2.388 2.389-2.388 1.318 0 2.389 1.07 2.389 2.389 0 1.318-1.07 2.389-2.39 2.389z"
        }), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("linearGradient", {
          id: "prefix__paint0_linear",
          x1: "16",
          x2: "16",
          y1: "0",
          y2: "32",
          gradientUnits: "userSpaceOnUse"
        }, /*#__PURE__*/_react.default.createElement("stop", {
          stopColor: "#FA6400"
        }), /*#__PURE__*/_react.default.createElement("stop", {
          offset: "1",
          stopColor: "#F7902A"
        })))));

      case -1.1:
        return /*#__PURE__*/_react.default.createElement(StyledEmoji, (0, _extends2.default)({
          size: size
        }, rest), /*#__PURE__*/_react.default.createElement("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "38",
          height: "38",
          fill: "none",
          viewBox: "0 0 38 38"
        }, /*#__PURE__*/_react.default.createElement("circle", {
          cx: "15.998",
          cy: "15.998",
          r: "15.998",
          fill: "#fff"
        }), /*#__PURE__*/_react.default.createElement("path", {
          fill: "#797979",
          d: "M16 0C7.178 0 0 7.178 0 16s7.178 16 16 16 16-7.178 16-16S24.822 0 16 0zM8 13.6c0-1.325 1.075-2.4 2.4-2.4s2.4 1.075 2.4 2.4-1.075 2.4-2.4 2.4S8 14.925 8 13.6zM9.6 24s1.6-4.8 6.4-4.8c4.8 0 6.4 4.8 6.4 4.8H9.6zm11.989-8.022c-1.319 0-2.389-1.07-2.389-2.39 0-1.318 1.07-2.388 2.389-2.388 1.318 0 2.389 1.07 2.389 2.389 0 1.318-1.07 2.389-2.39 2.389z"
        }), /*#__PURE__*/_react.default.createElement("path", {
          fill: "#FA6400",
          d: "M30 23.333c-3.676 0-6.667 2.99-6.667 6.667 0 3.676 2.99 6.667 6.667 6.667 3.676 0 6.667-2.991 6.667-6.667 0-3.676-2.991-6.667-6.667-6.667zm2.805 8.529l-.943.943L30 30.943l-1.862 1.862-.943-.943L29.057 30l-1.862-1.862.943-.943L30 29.057l1.862-1.862.943.943L30.943 30l1.862 1.862z"
        })));

      default:
        return null;
    }
  };

  _exports.RatingEmojis = RatingEmojis;
});